import { render, staticRenderFns } from "./BannerReactiveBilling.vue?vue&type=template&id=61c1b7bc&scoped=true&"
import script from "./BannerReactiveBilling.vue?vue&type=script&lang=ts&"
export * from "./BannerReactiveBilling.vue?vue&type=script&lang=ts&"
import style0 from "./BannerReactiveBilling.vue?vue&type=style&index=0&id=61c1b7bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c1b7bc",
  null
  
)

export default component.exports